import { bl_fi_budget_fiscal_period_RowClass } from "../../../dbschema/bl_fi_budget_fiscal_period.model";
import { bl_fi_budget_fiscal_year_RowClass } from "../../../dbschema/bl_fi_budget_fiscal_year.model";
import { BaseContainerModel } from "../../base-container.model";

export class BudgetFiscalYearPeriodContainerModel extends BaseContainerModel {
  bl_fi_budget_fiscal_year: bl_fi_budget_fiscal_year_RowClass =
    new bl_fi_budget_fiscal_year_RowClass();
  bl_fi_budget_fiscal_period: bl_fi_budget_fiscal_period_RowClass[] = [];
}
